import './PeopleCard.css';
import NamePill from '../NamePill/NamePill';
import TagPills from '../TagPills/TagPills';
import { getImageSrc } from '../../utils/imageUtils';

export default function PeopleCard({
  title,
  profile_image,
  name,
  designation,
  date,
  tags = [],
}) {
  const iconBase = process.env.PUBLIC_URL || '';
  const imageSrc = getImageSrc(profile_image, { fallback: `${iconBase}/people_default.png` });
  const imageAlt = name ? `${name} profile` : 'Profile image';

  return (
    <article className="PeopleCard">
      {title ? <NamePill text={title} align="center" className="PeopleCard__title" /> : null}
      <span className="PeopleCard__imageWrap">
        <img
          className="PeopleCard__image"
          src={imageSrc}
          alt={imageAlt}
          loading="lazy"
          decoding="async"
        />
      </span>
      {name ? <div className="PeopleCard__name">{name}</div> : null}
      {designation ? <div className="PeopleCard__designation">{designation}</div> : null}
      {date ? <div className="PeopleCard__date">{date}</div> : null}
      <TagPills tags={tags} position="bottom" className="PeopleCard__tags" />
    </article>
  );
}
